import { matchSorter } from 'match-sorter';
import {
  AlignmentStatusDropdownValues,
  AlignmentIssueDropdownValues,
} from '../constants/alignment';

const filterByCompetition = (competitions, event) =>
  !competitions ||
  competitions.length === 0 ||
  competitions.some(
    (competition) => competition.value === event.videoInfo.competition,
  );

const filterBySeason = (seasons, event) =>
  !seasons ||
  seasons.length === 0 ||
  seasons.some((season) => season.value === event.videoInfo.seasonName);

const filterByAlignmentIssue = (alignmentIssue, event) =>
  [AlignmentIssueDropdownValues.ALL, undefined].includes(alignmentIssue) ||
  event.videoInfo.alignmentIssue === alignmentIssue;

const filterByAlignmentStatus = (alignmentStatus, event) =>
  [AlignmentStatusDropdownValues.ALL, undefined].includes(alignmentStatus) ||
  (alignmentStatus === AlignmentStatusDropdownValues.AWAITING_REVIEW
    ? event.videoInfo.alignmentStatus === null
    : event.videoInfo.alignmentStatus === alignmentStatus);

const sortByMatchDate = (a, b) =>
  a.item.videoInfo.matchDate - b.item.videoInfo.matchDate;

/*
 * Filter videos by competition, alignment issue, alignment status, and match id
 * Fuzzy match on matchId
 */
export const filterVideos = (
  videos,
  competitions,
  seasons,
  alignmentIssue,
  alignmentStatus,
  matchId,
) => {
  const filteredEvents = videos?.filter((event) => {
    const competitionMatch = filterByCompetition(competitions, event);
    const seasonMatch = filterBySeason(seasons, event);
    const issueMatch = filterByAlignmentIssue(alignmentIssue, event);
    const statusMatch = filterByAlignmentStatus(alignmentStatus, event);
    return competitionMatch && seasonMatch && issueMatch && statusMatch;
  });

  return matchId
    ? matchSorter(filteredEvents, matchId, {
        baseSort: sortByMatchDate,
        keys: ['videoReference.matchId'],
        threshold: matchSorter.rankings.CONTAINS,
      })
    : filteredEvents;
};

export default filterVideos;
